import {
  CLOSEJWEB,
  CREATEACCOUNT,
  DSP,
  SHOWALL,
  SIGNIN,
  REDIRECT,
  CALLTYPE,
  CALLVALUE,
  GOHOME,
  SHOWHPPLUSCONVERSION,
  SHOWHPXBANNER,
  ISHPXSCANSUPPORTED,
  IOS,
  MAC,
  WINDOWS,
  LAUNCHTILE,
  LAUNCHHPX,
  INTERSTITIAL,
  NativeTriggers,
  DEEPLINK,
  PRINTER_INFO_KEYWORDS,
  ANDROID
} from './constants';
import {
  sendShowDSPEvent,
  sendShowCreateAccountEvent,
  sendShowSignInEvent,
  sendLaunchUrlEvent,
  sendJarvisEventFinishedEvent,
  sendShowHPPlusConversionEvent,
  sendShowHpxBannerEvent,
  sendLaunchHpxEvent,
  sendShowLaunchTileEvent,
  sendDeepLinkEvent
} from './events';
import { closeServiceInstance } from './plugins/serviceRouting';
export const triggerEvent = (
  target,
  engagementId,
  jumpId,
  sessionId,
  locale,
  rawUDLData,
  tileAnalyticsData,
  isFullScreen,
  hostPlatform,
  splunkEnv
) => {
  console.log('target', JSON.stringify(target));

  console.log('rawUDLData', JSON.stringify(rawUDLData));

  // Is triggering Native app event
  const isNativeTrigger = NativeTriggers.includes(target.type);
  // If URL, is it external URL ( Not intertsitial)
  const isExternalRedirect =
    target.type === REDIRECT &&
    ((target.value && target.value.indexOf('http://') === 0) ||
      target.value.indexOf('https://') === 0);
  const isURLForPrinterInfo =
    target.type === REDIRECT &&
    target.value &&
    PRINTER_INFO_KEYWORDS.some(word => target.value.includes(word));
  const useExternalBrowser = target?.isOpenInExternalBrowser;

  closeCurrentJwebScreen(target, isFullScreen, hostPlatform, isNativeTrigger, isExternalRedirect);
  switch (target.type) {
    case REDIRECT: {
      let url = target.value;
      if (!isExternalRedirect) {
        const queryObject = {
          engagementId,
          jumpId,
          sessionId,
          locale,
          name: tileAnalyticsData ? tileAnalyticsData.name : '',
          fullscreen: !!isFullScreen
        };
        if (rawUDLData) {
          queryObject.appInstanceID = rawUDLData.appInstanceID;
          queryObject.deviceID = rawUDLData.deviceID;
          queryObject.productNumber = rawUDLData.product_number;
          queryObject.printerSessionId = rawUDLData.printer_sessionId;
        }
        const queryString = queryStringFromObject(queryObject, true);
        url = `${window.location.origin}${target.value}${queryString}`;
        console.log('url', url, 'queryString', queryString);
      } else if (isURLForPrinterInfo) {
        let tempURL = new URL(url);

        let params = new URLSearchParams(tempURL.search);
        let [printerUUID, printerModel, printerSessionID] = PRINTER_INFO_KEYWORDS.map(word =>
          params.get(word)
        );
        // If printer Info is null or empty, set it to a value and update the URL
        if (rawUDLData && (!printerUUID || !printerModel || !printerSessionID)) {
          printerUUID = rawUDLData.deviceID;
          printerModel = rawUDLData.product_number;
          printerSessionID = rawUDLData.printer_sessionId;
          params.set('printerModel', printerModel);
          params.set('printerUUID', printerUUID);
          params.set('printerSessionID', printerSessionID);
          tempURL.search = params.toString();
          url = tempURL.toString();
        }
        console.log('Final url', url);
      }
      // if triggered from fullscreen or interstitial
      // 1. just do window the redirect if opening another internal URL(like another interstitial).
      // 2. else launch another jweb for external URL.
      if ((target.source === 'screen' || isFullScreen) && !isExternalRedirect) {
        window.location.href = window.encodeURI(url);
      } else {
        sendLaunchUrlEvent(
          window.encodeURI(url),
          isExternalRedirect ? true : !!target.nativeNavBar,
          useExternalBrowser
        );
      }
      break;
    }
    case INTERSTITIAL: {
      const interstitialUrl = `/1/offer?screenId=${engagementId}${
        target.value !== '' ? '-' + target.value : '-interstitial'
      }`;
      const queryObject = {
        engagementId,
        jumpId,
        sessionId,
        locale,
        name: tileAnalyticsData ? tileAnalyticsData.name : '',
        fullscreen: !!isFullScreen,
        splunkEnv
      };
      if (typeof target.segmentName !== 'undefined') queryObject.segmentName = target.segmentName;
      if (rawUDLData) {
        queryObject.appInstanceID = rawUDLData.appInstanceID;
        queryObject.deviceID = rawUDLData.deviceID;
        queryObject.productNumber = rawUDLData.product_number;
        queryObject.printerSessionId = rawUDLData.printer_sessionId;
      }
      const queryString = queryStringFromObject(queryObject, true);
      const url = `${window.location.origin}${interstitialUrl}${queryString}`;

      if (target.source === 'screen' || isFullScreen) {
        window.location.href = window.encodeURI(url);
      } else {
        {
          sendLaunchUrlEvent(window.encodeURI(url), !!target.nativeNavBar);
        }
      }
      break;
    }
    case DSP: {
      sendShowDSPEvent(jumpId);
      break;
    }
    case CREATEACCOUNT: {
      sendShowCreateAccountEvent(jumpId);
      break;
    }
    case SIGNIN: {
      sendShowSignInEvent(jumpId);
      break;
    }
    case SHOWALL: {
      const queryString = queryStringFromObject({
        sessionId,
        deviceID: rawUDLData.deviceID,
        product_number: rawUDLData.product_number,
        printerSessionId: rawUDLData.printer_sessionId,
        appInstanceId: rawUDLData.appInstanceID,
        locale: locale,
        fullscreen: true
      });
      const url = `${target.value}${queryString}`;
      sendLaunchUrlEvent(url);
      break;
    }
    case CLOSEJWEB: {
      if (isFullScreen) {
        window.history.back();
      } else {
        closeServiceInstance();
      }
      break;
    }
    case GOHOME: {
      sendJarvisEventFinishedEvent({ navigateHome: true });
      break;
    }
    case SHOWHPPLUSCONVERSION: {
      const eventData = createHpPlusEventData(jumpId);
      sendShowHPPlusConversionEvent(eventData);
      break;
    }
    case SHOWHPXBANNER: {
      sendShowHpxBannerEvent();
      break;
    }
    case LAUNCHHPX: {
      sendLaunchHpxEvent();
      break;
    }
    case LAUNCHTILE: {
      sendShowLaunchTileEvent({
        tileName: target.appTile
      });
      break;
    }
    case DEEPLINK: {
      sendDeepLinkEvent({
        value: target.value
      });
      break;
    }
    default:
      break;
  }
};

const queryStringFromObject = (obj, withInitialParam) => {
  const pairs = Object.entries(obj);
  return pairs.reduce(
    (acc, [key, value], index) => {
      if (key && value) {
        return index ? `${acc}&${key}=${value}` : `${acc}${key}=${value}`;
      }
      return acc;
    },
    withInitialParam ? '&' : '?'
  );
};

function closeCurrentJwebScreen(
  target,
  fullscreen,
  hostPlatform,
  isNativeTrigger,
  isExternalRedirect
) {
  const isIOS = hostPlatform === IOS;
  const isMac = hostPlatform === MAC;
  const isWindows = hostPlatform === WINDOWS;
  const isAndroid = hostPlatform === ANDROID;

  // Full screen CEC is loaded in Jweb
  // If a tile in fullscreen triggers any native flow like dsp, signin, createaccount etc.
  // Then fullscreen has to be closed to show triggered flow.
  // Otherwise the triggered flow is loaded behind fullscreen and Apps are not aware of open fullscreen as they don't control service routing stack.
  // IOS and MAC are able to handle hybrid stack and therefore fullscreen isn't closed for better UX.
  if (target.source === 'tile') {
    if ((isNativeTrigger || isExternalRedirect) && fullscreen && !isIOS && !isMac && !isWindows) {
      sendJarvisEventFinishedEvent();
    } else if (target.type === 'dsp') {
      sendJarvisEventFinishedEvent({ followedByEvent: true });
    }
  } else {
    // Similarly for events triggered from interstitial screens
    // windows and android -> close the jweb always
    // ios and mac -> close the jweb only target event is not opening another jweb.
    if (isNativeTrigger || isExternalRedirect) {
      if (isWindows || isAndroid) {
        sendJarvisEventFinishedEvent({ followedByEvent: true }); // close the JWeb
      } else if (target.type !== REDIRECT) {
        fullscreen
          ? window.history.back()
          : sendJarvisEventFinishedEvent({ followedByEvent: true });
      }
    }
  }
}

function createHpPlusEventData(jumpId) {
  return {
    features: {
      ShowHPPlusConversion: true
    },
    ucde: {
      uiinfos: {
        callType: CALLTYPE,
        callValue: CALLVALUE
      }
    },
    udl: {
      encrypted: {
        JumpID: jumpId
      }
    }
  };
}
